import ReactDOMServer from 'react-dom/server';

export type VIDEO_ENTRY = {
   youtubeId: string;
   date: Date;
   html: string;
}

export const concertDetails: Array<VIDEO_ENTRY> = [
   // addVideo snippet available
   {
      youtubeId: 'za1if1qzdrA',
      date: new Date('2021/04/10 12:00'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
         <br />
         I am returning again to Bach but this time paired with a Schubert Impromptu!
         <br />
         The extract I play from Bach's Partita No.1 is the third passage called the Courante. I follow this with Schubert's Impromptu in G-flat major.
         <br />
         I found both to be a real challenge this week.  They are both complex pieces that require my full attention and anything other than 100% and they fail spectacularly! I think this is why they are so enjoyable to get right, it is like walking a tightrope.  Or at least it is how I imagine it would be to walk a tightrope, it isn't something I have first-hand experience of!
         <br />
         I hope you enjoy them!
         </p>
      )
   },
   {
      youtubeId: 'FSXib_umRK8',
      date: new Date('2021/04/03 12:00'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
<br />
I have a new suite of pieces tonight that I initially composed when I was 6 years old! I decided to revisit them and turn them into more mature compositions and I had a great time doing it.
<br />
My first video is a little Q&#38;A session with my dad talking about the 4 pieces and the history of the compositions.
<br />
Then we have the suite itself, called "Na Ràithean" or "The Seasons".
<br />
Then we have a little treat, some audio from February 2011 of me at the piano playing two of the original pieces.
<br />
I hope you enjoy them!
</p>
      )
   },
   {
      youtubeId: 'PqaKCC_pV7E',
      date: new Date('2021/03/27'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
            <div>Tonight I decided to revisit my first ever Saturday Concert and play a couple of Bill Withers songs. I decided to include the lyrics here since Bill always wrote such positive and uplifting lyrics and it seems a shame you won't hear him sing them.</div>
            <h2 className="pt-4 text-lg underline">"Grandma's Hands"</h2>
            <div className="p-2">
               [Verse 1]<br />
               Grandma's hands clapped in church on Sunday morning<br />
               Grandma's hands played a tambourine so well<br />
               Grandma's hands used to issue out a warning<br />
               She'd say, "Billy don't you run so fast<br />
               Might fall on a piece of glass<br />
               Might be snakes there in that grass,"<br />
               Grandma's hands<br />
            </div>
            <div className="p-2">
               [Verse 2]<br />
               Grandma's hands sooth the local unwed mother<br />
               Grandma's hands used to ache sometimes and swell<br />
               Grandma's hands used to lift her face and tell her<br />
               She'd say, "Baby Grandma understands<br />
               That you really loved that man<br />
               Put yourself in Jesus' hands."<br />
               Grandma's Hands<br />
            </div>
            <div className="p-2">
               [Verse 3]<br />
               Grandma's hands used to hand me piece of candy<br />
               Grandma's hands picked me up each time I fell<br />
               Grandma's hands, boy they really came in handy<br />
               She'd say, " Mattie don't you whip that boy<br />
               What you want to spank him for?<br />
               He didn't drop no apple core,"<br />
               But I don't have Grandma anymore<br />
               If I get to heaven I'll look for<br />
               Grandma's hands<br />
            </div>

            <h2 className="pt-4 text-lg underline">"Lean on me"</h2>
            <div className="p-2">
               [Verse 1]<br />
               Sometimes in our lives, we all have pain<br />
               We all have sorrow<br />
               But if we are wise<br />
               We know that there's always tomorrow<br />
            </div>
            <div className="p-2">
               [Chorus]<br />
               Lean on me when you're not strong<br />
               And I'll be your friend<br />
               I'll help you carry on<br />
               For it won't be long<br />
               'Til I'm gonna need<br />
               Somebody to lean on<br />
            </div>
            <div className="p-2">
               [Verse 2]<br />
               Please swallow your pride<br />
               If I have things you need to borrow<br />
               For no one can fill<br />
               Those of your needs<br />
               That you won't let show<br />
            </div>
            <div className="p-2">
               [Bridge]<br />
               You just call on me, brother, when you need a hand<br />
               We all need somebody to lean on<br />
               I just might have a problem that you'll understand<br />
               We all need somebody to lean on<br />
            </div>

            <div className="p-2">
               [Chorus]<br />
               Lean on me when you're not strong<br />
               And I'll be your friend<br />
               I'll help you carry on<br />
               For it won't be long<br />
               'Til I'm gonna need<br />
               Somebody to lean on<br />
            </div>
            <div className="p-2">
               [Bridge]<br />
               You just call on me, brother, when you need a hand<br />
               We all need somebody to lean on<br />
               I just might have a problem that you'll understand<br />
               We all need somebody to lean on<br />
            </div>
            <div className="p-2">
               [Verse 3]<br />
               If there is a load you have to bear<br />
               That you can't carry<br />
               I'm right up the road<br />
               I'll share your load<br />
               If you just call me<br />
            </div>
I hope you enjoy them!
   </p>
      )
   },
   {
      youtubeId: 'ui7BrJh0JYg',
      date: new Date('2021/03/20'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
            <br />
            Tonight I have two gentle and peaceful pieces from Debussy and Grieg.
            <br />
            Like so much of his music, Debussy's "Bruyères" gently floats over the piano.
            The experts would call it a "pentatonic essay for piano" but I'd just call it
            mesmerising. "Bruyères" is translated as heather, so I like to think that it
            has a lot in common with a mist-covered Scottish hillside in the morning.
            <br />
            The "Notturno" or "Nocturne" is from Grieg's series called "Lyric Pieces",
            in this case, Book V (Op. 54) and it is number 4. Translated as "Night Piece"
            it is filled with gentle flowing movements that Grieg composed in the evening
            while taking in the beauty of the Norwegian mountains and fjords. It is very
            popular with piano teachers because it covers a lot of important techniques.
            However, taking a piece of this beauty and breaking it down into technique
            seems like a dreadful waste of a beautiful melody.
            <br />
            I hope you enjoy them!
         </p>
      )
   },
   {
      youtubeId: 'CZFTJZPZhs4',
      date: new Date('2021/03/13'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
<br />
I have another Bach and Chopin concert tonight!
<br />
I continue my performance of Bach's Partita No.1 with the "Allemande" section. It is relentlessly in motion flowing through its 3 minutes effortlessly.
<br />
Then I have the Chopin Polonaise "Héroïque", which as you might expect from Chopin, is perfect in every way!
<br />
I hope you enjoy them!
</p>
      )
   },
   {
      youtubeId: 'WvkK-AGkxWg',
      date: new Date('2021/03/06'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
<br />
One of my favourite things to do in life is to sit down at the piano and just let myself play.
<br />
I don't try to predict where I will go, or shape it into a structure. I just let myself be as free of restrictions as I can.
<br />
I do however choose the "language I speak in", so my improvisations are in G-sharp minor and A-flat major.
<br />
Sometimes, like with my A-flat major improvisation here, it takes me a while to find what I want to say. Then sometimes, like my G-sharp minor improvisation, I find my theme almost immediately and spend the rest of the time fully exploring it.
<br />
I hope you enjoy them!
</p>
      )
   },
   {
      youtubeId: "aCgHjhvvHRo",
      date: new Date("2021/02/27"),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
         <br />
         I have another pairing of Bach and Chopin tonight.
         <br />
         This time Bach Sarabande from Partita No1 in B-Flat Major and Chopin Grande Valse Brillante op 34 no 1.
         <br />
         I am really enjoying playing both ends of the classical spectrum and getting a chance to stretch very different piano-playing muscles!
         <br />
         I hope you enjoy them!
         </p>
      )
   },
   {
      youtubeId: 'wbNBLmj_BLU',
      date: new Date('2021/02/20'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
         <br />
         I am back after completing a special performance just for the SQA Exam Board last week!
         <br />
         I'm also back with a new piano!
         <br />
         Many thanks to Aunt Alison and Uncle Dave for their kindness...
         <br />
         Also to Gordon Bell of Gordon Bell Pianos in Aberdeen along with Lewis and Chris for delivering the
         piano.
         <br />
         And to our piano tuner Andrew Jamieson for all his help finding the perfect piano.
         <br />
         The piano is a Kawai Shigeru SK5.
         <br />
         Tonight I have two improvisations one in B major and one in B minor.
         <br />
         I hope you enjoy them!
         </p>
      )
   },
   {
      youtubeId: '2OQaQwekBaI',
      date: new Date('2021/01/30'),
      html: ReactDOMServer.renderToString(
         <p>
            Tonight I am continuing my Bach and Chopin series with the Bach Partita No 1 Minuet and the Chopin
            Mazurka, Op. 6, No. 1 in F-Sharp Minor.
         <br />
         I hope you enjoy them!
         </p>
      )
   },
   {
      youtubeId: 'RJYp2vsETmY',
      date: new Date('2021/01/23'),
      html: ReactDOMServer.renderToString(
         <p>
            In celebration of Robert Burns day (25th) I have a collection of Scottish songs (and one Irish).
         <br />
         The first two are Bonny Prince Charlie songs; "The Skye Boat Song" and "Will Ye No Come Back Again".
         <br />
         After that, we travel to Donegal for "My Lagan Love".
         <br />
         Then we return to Scotland with "Loch Lomond".
         <br />
         As is tradition, we finish with "Auld Lang Syne".
         <br />
         I hope you enjoy them!
         </p>
      )
   },
   {
      youtubeId: 'zmYGH6iVOtI',
      date: new Date('2021/01/09'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
         <br />
         Tonight I have a piece that I have loved for many years. It is "The Lark" by Mikhail Glinka (1804 -
         1857) a very influential Russian composer, arranged for piano years later by another influential
         Russian composer Mily Balakirev (1837 - 1910).
         <br />
         I love the gentle flowing beauty of the piece, very much like a skylark soaring above, and then my
         favourite part is the explosion of melody and notes during the two cadenzas!
         <br />
         "The Lark" is based on a Russian poem by the poet Nestor Kukolnik, a friend of Glinka and another
         influential Russian.
         <br />
         I hope you enjoy it!
         <span className="pt-4 block font-mono">
               Жаворонок (The lark)<br />
               <br />
               Между небом и землёй (Between the sky and the earth)<br />
               Песня раздаётся, (A song is heard)<br />
               Неисходною струёй (An unending stream of sound)<br />
               Громче громче льётся. (Pours louder, louder.)<br />
               <br />
               Не видать певца полей! (Unseen is the singer in the field )<br />
               Где поёт так громко (Where sings so loudly)<br />
               Над подруженькой своей (Above his mate )<br />
               Жаворонок звонкий. (The sonorous skylark.)<br />
               <br />
               Ветер песенку несёт, (The wind carries the song,)<br />
               А кому, не знает. (To whom, it does not know.)<br />
               Та, к кому она поймёт, (She to whom it is sung, )<br />
               От кого -- узнает! (She will understand who it is from.)<br />
               <br />
               Лейся ж, песенка моя, (Pour on, my song )<br />
               Песнь надежды сладкой... (Of sweet hope)<br />
               Кто-то вспомнит про меня (Someone remembers me )<br />
               И вздохнёт украдкой. (And sighs furtively.)<br />
            </span>
         </p>
      )
   },
   {
      youtubeId: 'wD4LthdxYQA',
      date: new Date('2021/01/02'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
   <br />
   This week I am performing my own "Neujahrskonzert der Wiener Philharmoniker" or "New Year's Concert of
   the Vienna Philharmonic".
   <br />
   Unfortunately, I don't have a Philharmonic orchestra.
   <br />
   And I am not in Vienna!
   <br />
   However, as a consolation, I have prepared my own piano arrangement of two famous pieces that might be
   played at such an event.
   <br />
   The first is the "Waltz of The Flowers" from The Nutcracker. Tchaikovsky's beautiful waltz that just
   sings and dances us into a good mood.
   <br />
   The second is "The Blue Danube" waltz by Johann Strauss II and is truly a Vienna piece. You can just
   imagine the full orchestra playing it live on New Year's Day!
   <br />
   I hope you enjoy it!
   </p>
      )
   },
   {
      youtubeId: 'qTqwHx4FuiM',
      date: new Date('2020/12/26'),
      html: ReactDOMServer.renderToString(
         <p>
            My first piece tonight is a gentle rendition of "Angels From The Realms of Glory", calm and gentle,
            perfect if you are sitting on the couch still digesting yesterday's turkey!
   <br />
   My second piece is a song by the incredible Jazz singer Gregory Porter. It is a truly beautiful
   Christmas song, the words reflecting the best of our Christmas spirit, here are the words:
   <br />
   Well, they guild their houses in preparation for the King
   And they line the sidewalks
   With every sort of shiny thing
   They will be surprised
   When they hear him say
   <br />
   Take me to the alley
   Take me to the afflicted ones
   Take me to the lonely ones
   That somehow lost their way
   <br />
   Let them hear me say
   I am your friend
   Come to my table
   Rest here in my garden
   You will have a pardon
   <br />
   I hope you enjoy it!
   </p>
      )
   },
   {
      youtubeId: '53aarjJulGw',
      date: new Date('2020/12/19'),
      html: ReactDOMServer.renderToString(
         <p>
            Tonight I have more Christmas tunes!
   <br />
   I hope you enjoy them!
   </p>
      )
   },
   {
      youtubeId: 'R_fSvHhzo_4',
      date: new Date('2020/12/12'),
      html: ReactDOMServer.renderToString(
         <p>
            Tonight I am playing two Christmas themed pieces.
   <br />
   The first is "Carol of the Bells" and I've enlisted the help of an unusually attractive accordion
   player for the duet!
   <br />
   The second is based on the Christmas carol "Joy to the World" but because of the unsettling year we
   have all had, I have incorporated a hidden reversal of the original motif to give it a significantly
   more reflective tone.
   <br />
   I hope you enjoy it!
   </p>
      )
   },
   {
      youtubeId: 'g-ruJuJyLM4',
      date: new Date('2020/12/05'),
      html: ReactDOMServer.renderToString(
         <p>
            Tonight I am getting right into the Christmas spirit with some Christmas surprises!
   <br />
   I hope you enjoy it!
   </p>
      )
   },
   {
      youtubeId: '-FauDf98IqQ',
      date: new Date('2020/11/28'),
      html: ReactDOMServer.renderToString(
         <p>
            Tonight I am playing a suite of pieces by the Danish composer Carl Nielsen (1865-1931). I will be
            playing Fem Klaverstykker or 'Five Piano Pieces'.
   <br />
   To round off the evening we have a little Chopin for dessert; Étude Op. 10 No. 9 in F minor.
   <br />
   I hope you enjoy it!
   </p>
      )
   },
   {
      youtubeId: 'l1RN2YnbQPM',
      date: new Date('2020/11/21'),
      html: ReactDOMServer.renderToString(
         <p>
            Tonight I am playing Chopin's Fantaisie in F minor, Op. 49.
   <br />
   I hope you enjoy it!
   </p>
      )
   },
   {
      youtubeId: 'PAGwbwNiq3c',
      date: new Date('2020/11/14'),
      html: ReactDOMServer.renderToString(
         <p>
            On the 6th of August 2020, I recorded my entry for the LTCL Piano Performance Diploma. It had to be a
            single continuous take!
   <br />
   It is a balanced recital just under 40 minutes in length with Scarlatti, Mozart, Chopin and Debussy.
   <br />
   Now that I have the results back I can post the video for everyone to see.
   <br />
   I got 88/100, which I was delighted by.
   <br />
   I hope you enjoy it!
   </p>
      )
   },
   {
      youtubeId: 'QPkPZRWCAFQ',
      date: new Date('2020/11/07'),
      html: ReactDOMServer.renderToString(
         <p>
            I have two etudes for you tonight.
   <br />
   I will often write an etude around a concept that I am trying to master on the piano. I will have an
   idea and will construct a piece that lets me play around with that idea.
   <br />
   In the first etude, in C# minor, I was playing around with melodic shape and dynamic lines. Once I had
   finished, I built this piece up from the experimental parts.
   <br />
   In the second etude, in A flat major, I was trying to produce a piece that challenged one of my
   weakest areas, jumps with crossing over hands. Once I had finished I realised that I rather enjoyed
   the piece and it made me think of "fireworks", which is quite apt so soon after Guy Fawkes Night on
   the 5th!
   </p>
      )
   },
   {
      youtubeId: 'btQcThieMfg',
      date: new Date('2021/02/27'),
      html: ReactDOMServer.renderToString(
         <p>
            I recorded the Brahms Rhapsody No.1 in B minor today while "Storm Aiden" was battering the house with
            high winds and rain!
   <br />
   It is quite a fittingly stormy piece with alternating swells of power and quiet moments of respite.
   <br />
   This is certainly not the final version of this piece, I will revisit it over the next few months as I
   unlock different levels of performance in the piece.
   </p>
      )
   },
   {
      youtubeId: 'CG1LHu7Uhoc',
      date: new Date('2020/10/25'),
      html: ReactDOMServer.renderToString(
         <p>
            Two improvisations tonight.
   <br />
   The first a bright scherzo in G major, happy and light and fitting for the key of G major.
   <br />
   The second is a nocturne in G minor, more of a gentle evening piece. Happy and light but more relaxed
   and comfortable.
   <br />
   The first is "get up and dance" because you are happy. The second is "settle down and relax" because
   you are happy.
   </p>
      )
   },
   {
      youtubeId: '5xEClVfTObE',
      date: new Date('2020/10/17'),
      html: ReactDOMServer.renderToString(
         <p>
            A pair of polonaises!
   </p>
      )
   },
   {
      youtubeId: 'Z40svGGFCa8',
      date: new Date('2020/10/10'),
      html: ReactDOMServer.renderToString(
         <p>
            This is a special concert, it is my Aunt Alison's 70th birthday! She has been a big part of all the
            most important musical events in my life. She has always been super encouraging and helped keep my
            spirits up. She is one of the most positive and helpful people I have ever met.
   <br />
   I have three compositions tonight.
   <br />
   1: "Airson Alison" a Fanfare and Polonaise in Ab major.
   "Airson Alison" means "For Alison" in Gaelic. It is the kind of triumphant birthday celebration
   fanfare that would be fitting such an important occasion.
   <br />
   2: "An Turas" A Journey in Bb major
   "An Turas" means "The Journey" in Gaelic.
   <br />
   3: "Eating Lobster"
   As Rumi said in the 13th Century "Fihi Ma Fihi". I can't really explain the piece or the title. It
   just "is what it is".
   <br />
   I hope you enjoy listening to them as much as I enjoyed playing them.
   </p>
      )
   },
   {
      youtubeId: '9I5vxKUWH3U',
      date: new Date('2020/10/03'),
      html: ReactDOMServer.renderToString(
         <p>
            Greetings!
   <br />
   I have a slightly longer concert today, 20 minutes, as I'm trying out three songs together to see how
   well they complement each other.
   <br />
   First Ludwig van Beethoven's Piano Sonata No. 23 in F minor, Op. 57 1st movement well known as the
   Appassionata ("passionate" in Italian). I love the key, the melody but most of all I love the passion
   of this piece! I slip most easily into "passionate and maybe slightly melodramatic"!!
   <br />
   Second, and melting away the rawness of Beethoven, is Debussy's Prelude Bk.2 No.8 "Ondine" (water)
   which is so sophisticated, delicate and complex.
   <br />
   Thirdly I revisit Chopin's Sonata in B minor 4th movement that I played in my 25th July concert.
   <br />
   When learning pieces there are several stages that I have to journey through. In the early stages, I
   need to get from enjoying the piece to understanding the piece. Quite often all that is required is
   time with the process. Sometimes I can feel the piece immediately! Other times it requires deliberate
   effort to correctly position the piece in my mind.
   <br />
   Even after the piece is complete and has been performed, in fact almost immediately after I perform a
   piece, I discover new ideas that I want to include in my playing. I've been working on parts of the
   Sonata since my last performance and this is why I wanted to play it again.
   <br />
   Maybe you will notice an improvement, maybe you will prefer the original performance, maybe you won't
   even notice the difference!
   </p>
      )
   },
   {
      youtubeId: 'wIdBAn3I_Vg',
      date: new Date('2020/09/26'),
      html: ReactDOMServer.renderToString(
         <p>
            I have improvisations in B flat minor and B flat major today. I'd say they are a little more
            melancholy, a little more introspective than usual so bring a hot chocolate and some comfortable
            slippers.
   </p>
      )
   },
   {
      youtubeId: 'it5XOxBCOOc',
      date: new Date('2020/09/19'),
      html: ReactDOMServer.renderToString(
         <p>
            I have recorded two compositions from my first CD "Mysterious Pathways Volume One".
   <br />
   "Wallace At Lanark" is very much a Scottish piece inspired by the waterfalls of New Lanark and the
   tragic story of William Wallace.
   <br />
   "Of The Sea" was written standing on a beach in Seahouses, England, half in the water, half out,
   listening to the waves break and the Kitty Wakes feed their young and imagining life under the water
   in the deep sea.
   </p>
      )
   },
   {
      youtubeId: 'CH3hsz-6Cqk',
      date: new Date('2020/09/12'),
      html: ReactDOMServer.renderToString(
         <p>
            I have recorded two improvisations this week.
   <br />
   The first is in F minor and is a rainy day in September.
   <br />
   The second is in F major and if you can't go outside because it is raining you may as well stay inside
   and dance!
   </p>
      )
   },
   {
      youtubeId: 'YWWpugInAVg',
      date: new Date('2020/09/05'),
      html: ReactDOMServer.renderToString(
         <p>
            Chopin for me is like air, I cannot imagine living without it!
   <br />
   This week I have Chopin's 1st Scherzo which is truly wonderful, it is pure chaotic genius combining
   beautiful melodic lines with a cacophony of harsh noise. One of my favourite scherzos.
   <br />
   The second piece was transcribed for the piano by the Italian composer Giovani Sgambati. Its beautiful
   melody is from Gluck’s “Dance of the Blessed Spirits” where it tells the story of the love and tragedy
   of Orphius and Euridice. It is a truly beautiful work of art.
   </p>
      )
   },
   {
      youtubeId: '7KgpFRwKr6I',
      date: new Date('2020/08/29'),
      html: ReactDOMServer.renderToString(
         <p>
            This week I improvise in the keys of E major and E Minor. I find both tremendously comfortable keys to
            improvise in. Perhaps it is because the good mix of black and white keys provides a pleasing tactile
            environment to anchor my hands in the correct positions.
   <br />
   The first is E Minor and is in the "Mazurka" style I have been experimenting with recently. We dance
   for a while around the keyboard.
   <br />
   The second is in E major and I can only attribute it to having a belly full of delicious spaghetti
   bolognese! You should definitely try eating a big bowl of spaghetti and see what comes out when you
   play.
   </p>
      )
   },
   {
      youtubeId: 'ROgcxHGw5ZY',
      date: new Date('2020/08/22'),
      html: ReactDOMServer.renderToString(
         <p>
            I have a couple of improvisations tonight in the keys of E flat minor and E flat major! I have had
            some ideas floating around my head all week and this is my first attempt at getting those ideas on the
            piano.
   <br />
   I hope you enjoy them!
   <br />
   Maybe they will stay as improvisations or I may turn them into a proper composition some time.
   </p>
      )
   },
   {
      youtubeId: 'q05EnDOZQCk',
      date: new Date('2020/08/15'),
      html: ReactDOMServer.renderToString(
         <p>
            I have three pieces tonight;
   <br />Sonata in G minor, K.426 by Scarlatti, Sonata in G major, K.427 also by Scarlatti and finally
   Rondo in A minor, K. 511 by Mozart.
   </p>
      )
   },
   {
      youtubeId: 'Rkv0VyozyUk',
      date: new Date('2020/08/08'),
      html: ReactDOMServer.renderToString(
         <p>
            I have two pieces tonight;
         <br />the gentle "Ondine"(water) by Debussy, and Chopin's Scherzo No.3 which has my favourite last
         minute of any piece I play!
         </p>
      )
   },
   {
      youtubeId: 'n2A3yO6KPB4',
      date: new Date('2020/08/01'),
      html: ReactDOMServer.renderToString(
         <p>
            I continue my series of improvisations through the keys and have now arrived at the keys of D major
            and D minor.
            <br />
            As I started my D minor improvisation I could really feel a ghost story developing. It is spooky in
            places and quite haunting. Like all good ghost stories, it ends a little bit sinister!
            <br />
            My D major improvisation is a little harder to put into words. It is a dance (a waltz) but not between
            two people. It is the kind of dance my sister does with her dance school where there are many
            different dancers all telling a story together through dance. You might call it a Ballade. The primary
            key, D major, is the lead dancer for sure but E minor, B major, F sharp major and F sharp minor all
            dance in this song. I float between the keys but also right out of any key structure in several
            places. The dance returns to D major in the end, well just before the end. In the final ending, the
            dancers go pretty experimental and create a suspenseful disjointed harmony in their last pose, as
            everybody looks on.
         </p>
      )
   },
   {
      youtubeId: 'RqKj3RbDKJA',
      date: new Date('2020/07/25'),
      html: ReactDOMServer.renderToString(
         <p>
            They say that variety is the spice of life; however, sometimes I want to eat chocolate chip ice cream
            three times in a row!
            I have three Chopin pieces today that I hope you will enjoy.
         </p>
      )
   },
   {
      youtubeId: '9J32Yy3ce9A',
      date: new Date('2020/07/18'),
      html: ReactDOMServer.renderToString(
         <p>
            This week is a little different. I recorded two modern songs; "Human" by Rag'n'Bone
            Man and "Take Me To Church" by Hozier.
         </p>
      )
   },
   {
      youtubeId: 'Bs7GWayDjt4',
      date: new Date('2020/07/11'),
      html: ReactDOMServer.renderToString(
         <p>
            This week I improvise in the keys of C# major and C# minor.
            <br />
            I have always found the notion of key signatures having different emotions strange. I view these keys
            as languages, and each language can express many different types of experience not just one that
            "fits" the key it is written in. In many ways writing some dramatic melancholy in C# major seems more
            enjoyable to me. Perhaps a little more creative.
            <br />
            It is kind of like saying, “French is the language of romance!” And expecting all French prose to be
            romantic.
            <br />
            The most famous thing about C# major is that no-one wants to read music written in it! Seven sharps
            make for some awkward notation. In fact, if this were a written piece the composer would probably have
            written it in D-flat major so there are only 5 flats to deal with.
            <br />
            Being blind I have no such limitations!
   </p>
      )
   },
   {
      youtubeId: 'J-9jb_7frG4',
      date: new Date('2020/07/04'),
      html: ReactDOMServer.renderToString(
         <p>
            I am on holiday for the next two weeks. Scotland is still mostly locked down so I'm not going anywhere
            but I am having a complete rest!
            <br />
            However, before my break I recorded some improvisations so that I would have something to post each
            Saturday.
            <br />
            Structured improvisation is something I do all the time as I find it enormously relaxing to allow my
            mind free space to wander. It wanders sometimes with purpose and sometimes just aimlessly however, I
            always encounter interesting things along the way!
            <br />
            This week improvisations in the key of C; first the major then the minor key.
         </p>
      )
   },
   {
      youtubeId: 'Q9-cETJ4iJs',
      date: new Date('2020/06/27'),
      html: ReactDOMServer.renderToString(
         <p>
            This week's performance features a special guest!
   </p>
      )
   },
   {
      youtubeId: 'D7LWMDZtTH4',
      date: new Date('2020/06/20'),
      html: ReactDOMServer.renderToString(
         <p>
            This week I recorded Chopin's Polonaise No.5 Op.44 and Debussy's Prelude No.7 Bk.2!
   </p>
      )
   },
   {
      youtubeId: 'G0oB_MSG2bA',
      date: new Date('2020/06/13'),
      html: ReactDOMServer.renderToString(
         <p>
            This week I recorded two improvisations based on Chopin
   </p>
      )
   },
   {
      youtubeId: 'n-EfvYJD4Lo',
      date: new Date('2020/06/06'),
      html: ReactDOMServer.renderToString(
         <p>
            This week I recorded Chopin's Scherzo No.2 in B-flat minor and Scriabin's Poem op.32 no.1
   </p>
      )
   },
   {
      youtubeId: 'EXbT8coHOj8',
      date: new Date('2020/05/30'),
      html: ReactDOMServer.renderToString(
         <p>
            Arrangements of "Fly me to the Moon" and "Somewhere over the rainbow".
   </p>
      )
   },
   {
      youtubeId: 'nsf2ziKjuJw',
      date: new Date('2020/05/23'),
      html: ReactDOMServer.renderToString(
         <p>
            My tribute to the late great Bill Withers
   </p>
      )
   },
];
